
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    modelValue: { type: String, required: true },
    value: { type: String, default: null },
    name: { type: String, default: "" },
  },
  emits: [
    "update:modelValue",
  ],
  computed: {
    selected(): boolean {
      return this.modelValue === this.value;
    },
  },
});
